import React, { useContext } from "react";
import { ProjectContext } from "../../context/project_context";
import ProjectNew from "./ProjectNew";
import ProjectUploadVideo from "./ProjectUploadVideo";
import ProjectSplitVideo from "./ProjectSplitVideo";
import ProjectGrabAudio from "./ProjectGrabAudio";
import ProjectTranscribeAudio from "./ProjectTranscribeAudio";
import ProjectIdentifyTranscriptErrors from "./ProjectIdentifyTranscriptErrors";
import ProjectFixTranscript from "./ProjectFixTranscript";
import ProjectSentenceBuilding from "./ProjectSentenceBuilding";
import ProjectSentenceThoughtFixing from "./ProjectSentenceThoughtFixing";
import ProjectTranslateToEnglish from "./ProjectTranslateToEnglish";
import ProjectCorrectEnglish from "./ProjectCorrectEnglish";
import ProjectGenerateTTS from "./ProjectGenerateTTS";
import ProjectPerLanguage from "./ProjectPerLanguage";
import ProjectStepper from "./ProjectStepper";
import ProjectVersionHistory from "./ProjectVersionHistory";
import ProjectMembers from "./ProjectMembers";
import FloatingMediaPlayer from "../../components/FloatingMediaPlayer";

// Statuses where the floating media player should be shown
const TRANSCRIPT_EDITING_STATUSES = [
  'fix_transcript',
  'sentence_building',
  'sentence_thought_fixing',
  'translate_to_english',
  'correct_english',
  'per_language'
];

const ProjectByStatus = () => {
  const { project, loading, updateProject, org_id, project_id, fetchProject, memberMode } = useContext(ProjectContext);

  if (loading) {
    return <div>Loading...</div>;
  }

  const handleStepClick = async (newStatus) => {
    if (project && newStatus !== project.project_status) {
      const confirmed = window.confirm(
        `Are you sure you want to change the project status from "${project.project_status.replace(/_/g, ' ')}" to "${newStatus.replace(/_/g, ' ')}"?`
      );
      
      if (!confirmed) {
        return;
      }
      
      await updateProject({
        ...project,
        project_status: newStatus
      });
    }
  };

  const handleStatusReverted = () => {
    // Refresh the project data after status revert
    if (fetchProject) {
      fetchProject();
    }
  };

  // Determine if we should show the floating media player
  const showMediaPlayer = project && TRANSCRIPT_EDITING_STATUSES.includes(project.project_status);

  return (
    <div className="project-status-container" style={{ paddingBottom: showMediaPlayer ? '100px' : '0' }}>
      {project && (
        <div style={{ marginBottom: '1rem' }}>
          <ProjectStepper 
            currentStatus={project.project_status} 
            onStepClick={handleStepClick}
            readOnly={memberMode}
          />
        </div>
      )}
      {!memberMode && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem',
          }}
        >
          <ProjectMembers org_id={org_id} project_id={project_id} />
          <ProjectVersionHistory 
            orgId={org_id} 
            projectId={project_id}
            onStatusReverted={handleStatusReverted}
          />
        </div>
      )}

      <div className="project-details">
        {project ? (
          <>
            {project.project_status == 'new' && <ProjectNew />}
            {project.project_status == 'upload_video' && <ProjectUploadVideo />}
            {project.project_status == 'split_video' && <ProjectSplitVideo />}
            {project.project_status == 'grab_audio' && <ProjectGrabAudio />}
            {project.project_status == 'transcribe_audio' && <ProjectTranscribeAudio />}
            {project.project_status == 'identify_transcript_errors' && <ProjectIdentifyTranscriptErrors />}
            {project.project_status == 'fix_transcript' && <ProjectFixTranscript />}
            {project.project_status == 'sentence_building' && <ProjectSentenceBuilding />}
            {project.project_status == 'sentence_thought_fixing' && <ProjectSentenceThoughtFixing />}
            {project.project_status == 'translate_to_english' && <ProjectTranslateToEnglish />}
            {project.project_status == 'correct_english' && <ProjectCorrectEnglish />}
            {project.project_status == 'generate_tts' && <ProjectGenerateTTS />}
            {project.project_status == 'per_language' && <ProjectPerLanguage />}
          </>
        ) : (
          <div>No project data available</div>
        )}
      </div>
      
      {/* Floating Media Player - shown during transcript editing stages */}
      {showMediaPlayer && <FloatingMediaPlayer />}
    </div>
  );
};

export default ProjectByStatus; 